import React from "react";
import { injectReducer } from "utils/redux/store";

const withReducer = (key, reducer) => (WrappedComponent) =>
  class extends React.PureComponent {
    constructor(props) {
      super(props);
      injectReducer(key, reducer);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export { withReducer };
